export default __webpack_public_path__ + "static/media/NotoSansKR-Black.dc4ea50f.woff";